export enum FleetDocType {
  VALID_ID = 'id',
  CPC_DOCUMENT = 'cpc_document',
}

export const FLEET_DOC_TYPE_LABELS: Record<FleetDocType, string> = {
  [FleetDocType.VALID_ID]: 'Valid ID',
  [FleetDocType.CPC_DOCUMENT]: 'Valid LTFRB CPC Document',
};
